import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { ObservableUtils } from "trade_utils_lib";
import { LocaleConfigMap } from "../hooks/LocaleConfig";
export var ZendeskWidget = /*#__PURE__*/function () {
  function ZendeskWidget() {
    _classCallCheck(this, ZendeskWidget);
  }
  _createClass(ZendeskWidget, null, [{
    key: "getApi",
    value: function getApi() {
      var ze = window["zE"];
      if (ze) {
        return ze;
      } else {}
      return function () {};
    }

    /**
     * Clears all forms in the Web Widget.
     */
  }, {
    key: "clear",
    value: function clear() {
      this.getApi()("webWidget", "clear");
    }

    /**
     * If the widget is opened, this command closes the widget and shows the launcher.
     */
  }, {
    key: "close",
    value: function close() {
      this.getApi()("webWidget", "close");
    }

    /**
     * Gets the current widget display. Depending on the features you have enabled, the command displays one of the following strings:
     * helpCenter, chat, contactForm, talk, contactOptions, answerBot, or hidden.
     */
  }, {
    key: "getDisplay",
    value: function getDisplay() {
      return this.getApi()("webWidget:get", "display");
    }

    /**
     * Hides all parts of the widget from the page. You can invoke it before or after page load.
     */
  }, {
    key: "hide",
    value: function hide() {
      this.getApi()("webWidget", "hide");
    }

    /**
     * Identifies an end user to Zendesk.
     *
     * If you have access to your end user's name and email, use this command to pass the details to your Zendesk Support account.
     *
     * If the user's email doesn't already exist in your Zendesk Support account, a new user record with the details is created.
     *
     * User record creation is queued and there might be a few minutes delay before the user record appears in your Zendesk Support account. However, during high API traffic periods, Identify API calls are throttled and might be dropped resulting in user records not being created.
     *
     * Identify API calls are throttled in several ways to prevent API abuse:
     *
     * IP address: A limit to identify users on a single IP address.
     * Limit the creation of user records per account: Up to 50,000 user records created daily by a Zendesk Support account.
     * Payload: Throttled when a Zendesk Support account makes more than one API call using the same email address every 12 hours.
     * The Identify API call occurs when the widget loads. In the event that a ticket is submitted before a user record is created by the Identify API call, the details in the ticket are used for creating a user record.
     *
     * Note:
     *
     * The Identify API call can only specify an organization when a user record is first created. It can't be used to modify organizations on existing user records.
     *
     * The Identify API only prepopulates the user's details in the Chat forms (Prechat, Chat Offline and Update Contact Details forms). To prefill all forms in any product configuration, please use prefill.
     */
  }, {
    key: "identify",
    value: function identify(data) {
      this.getApi()("webWidget", "identify", data);
    }

    /**
     * Clears an end user's session.
     */
  }, {
    key: "logout",
    value: function logout() {
      this.getApi()("webWidget", "logout");
    }

    /**
     * Pre-fills an end-user's details on forms inside the Web Widget.
     */
  }, {
    key: "prefill",
    value: function prefill(data) {
      this.getApi()("webWidget", "prefill", data);
    }

    /**
     * Completely resets the state of the widget. To preserve end-user experience, this API only functions when the widget is minimized.
     */
  }, {
    key: "reset",
    value: function reset() {
      this.getApi()("webWidget", "reset");
    }

    /**
     * Sets the widget locale.
     * @param locale
     */
  }, {
    key: "setLocale",
    value: function setLocale(locale) {
      var _map$locale;
      var map = {
        "en-US": "en"
      };
      this.getApi()("webWidget", "setLocale", LocaleConfigMap[(_map$locale = map[locale]) !== null && _map$locale !== void 0 ? _map$locale : locale].zendesk);
    }

    /**
     * Displays the widget on the host page in the state it was in before it was hidden.
     */
  }, {
    key: "show",
    value: function show() {
      this.getApi()("webWidget", "show");
    }

    /**
     * Opens the widget if it was closed, or closes the widget if it was opened.
     */
  }, {
    key: "toggle",
    value: function toggle() {
      this.getApi()("webWidget", "toggle");
    }

    /**
     * Updates the widget's zESettings. It can update multiple settings at once.
     */
  }, {
    key: "updateSettings",
    value: function updateSettings(data) {
      this.getApi()("webWidget", "updateSettings", data);
    }

    /**
     * Executes a callback when a user event is fired.
     */
  }, {
    key: "onUserEvent",
    value: function onUserEvent(listener) {
      this.getApi()("webWidget:on", "userEvent", listener);
    }

    /**
     * Reauthenticate users during a session. This API is particularly useful in these cases:
     *
     * Signing in a new user during an anonymous session without reloading the page.
     * Signing in a new user after a previous user has logged out without reloading the page.
     */
  }, {
    key: "reauthenticate",
    value: function reauthenticate() {
      this.getApi()("webWidget", "chat:reauthenticate");
    }

    /**
     * 刷新账号、联系邮箱。登录状态或联系邮箱发生变化时调用
     */
  }, {
    key: "refresh",
    value: function refresh() {
      var email = ZendeskWidget.contact;
      if (!email) {
        return;
      }
      if (ZendeskWidget.isLoginIn) {
        ZendeskWidget.updateSettings({
          webWidget: {
            authenticate: {
              chat: {
                jwtFn: function jwtFn(callback) {
                  var url = "/account/account/get_zendesk_token";
                  ObservableUtils.get(url, {
                    email: email
                  }, undefined, true).subscribe({
                    next: function next(data) {
                      callback(data.token);
                    },
                    error: function error(_error) {
                      console.log("get zendesk token error", _error);
                    }
                  });
                }
              }
            }
          }
        });
        ZendeskWidget.reauthenticate();
      } else {
        ZendeskWidget.logout();
        ZendeskWidget.reset();
        ZendeskWidget.identify({
          name: "".concat(email.split("@")[0], "#").concat(ZendeskWidget.clientId),
          email: email
        });
      }
    }
  }, {
    key: "setWidgetReady",
    value: function setWidgetReady(widgetReady) {
      ZendeskWidget.widgetReady = widgetReady;
      ZendeskWidget.refresh();
    }
  }, {
    key: "setLoginIn",
    value: function setLoginIn(isLoginIn) {
      ZendeskWidget.isLoginIn = isLoginIn;
      ZendeskWidget.refresh();
    }
  }, {
    key: "setContact",
    value: function setContact(contact) {
      ZendeskWidget.contact = contact.trim();
      ZendeskWidget.refresh();
    }
  }, {
    key: "setClientId",
    value: function setClientId(clientId) {
      ZendeskWidget.clientId = clientId;
      ZendeskWidget.refresh();
    }

    /**
     * Forces the widget to open.
     */
  }, {
    key: "open",
    value: function open() {
      this.getApi()("webWidget", "open");
    }
  }]);
  return ZendeskWidget;
}();
_defineProperty(ZendeskWidget, "widgetReady", false);
_defineProperty(ZendeskWidget, "isLoginIn", false);
_defineProperty(ZendeskWidget, "contact", "");
_defineProperty(ZendeskWidget, "clientId", "");